import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { CreateProductResponseDto } from "../../dtos/create-product-response-dto";
import type { EditProductDraftRequestDto } from "../../dtos/edit-product-draft-request-dto";
import { ProductService } from "../../services/product-service";

type UsePostEditProductDraftMutationParams = {
  options?: UseMutationOptions<
    CreateProductResponseDto,
    unknown,
    EditProductDraftRequestDto
  >;
};

export const usePostEditProductDraftMutation = ({
  options
}: UsePostEditProductDraftMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.editProductDraft({ payload });
    },
    ...options
  });
};
